import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseRequestListComponent } from '../base-request-list/base-request-list.component';
import { CommonGridComponent, GridColumn, GridAction } from '../../../shared/components/common-grid/common-grid.component';
import { RequestManagementService, PaginationInfo } from '../../../shared/services/request-management.service';

@Component({
  selector: 'app-completed',
  standalone: true,
  imports: [CommonModule, TranslateModule, CommonGridComponent],
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.scss']
})
export class CompletedComponent extends BaseRequestListComponent implements OnInit {
  
  /**
   * Define columns for completed grid (no Status column)
   */
  columns: GridColumn[] = [
    { key: 'number', label: 'Request Number', translationKey: 'requests.number' },
{
      key: 'module',
      label: 'Module',
      translationKey: 'requests.module',
      type: 'custom',
      customRender: (value: any) => this.translate.instant(`workflow_types.${value}`)
    },
        { key: 'taskClosedDate', label: 'Closed Date', translationKey: 'requests.closedDate', type: 'date' },
 //   { key: 'modifiedDate', label: 'Update Date', translationKey: 'requests.updateDate', type: 'date' }
  ];

  /**
   * Define actions available for completed requests (read-only)
   */
  actions: GridAction[] = [
    { 
      id: 'view', 
      label: 'common.view', 
      type: 'view', 
      icon: 'bi-eye'
    }
  ];

  constructor(private requestService: RequestManagementService, private router: Router,private translate: TranslateService
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch completed requests
   */
  override fetchRequests(pageNumber: number, delegationId?: number): void {
    this.loadingSubject$.next(true);

    const paginationInfo: PaginationInfo = this.buildPaginationInfo(pageNumber);

    this.requestService.getCompleted(paginationInfo, delegationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.updateRequests(response);
          this.loadingSubject$.next(false);
        },
        error: (error) => {
          this.handleError(error);
        }
      });
  }

  /**
   * Open the request when its row is clicked
   */
  onRowClick(row: any): void {
    this.viewRequest(row);
  }

  /**
   * Handle action triggered from grid
   */
  onTableAction(event: { action: GridAction; row: any }): void {
    switch (event.action.type) {
      case 'view':
        this.viewRequest(event.row);
        break;
    }
  }

  /**
   * View request details in task viewer (read-only)
   */
  private viewRequest(row: any): void {
    if (row?.id && row?.taskId) {
      this.router.navigate(['/requests/task-view', 2, row.id, row.taskId]);
    } else {
      console.warn('Cannot navigate to task viewer: missing request or task ID', row);
    }
  }
}
